import { testimonials } from '@/mocks/homeData';

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500" />
            <span className="text-xs font-semibold uppercase tracking-widest text-foreground-400">
              Community
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Echte Erfahrungen
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            Aus dem DACH-Raum
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className={`bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/60 ${
                index === testimonials.length - 1 ? 'opacity-70' : ''
              }`}
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-primary-400">
                    <i className="ri-star-fill"></i>
                  </span>
                ))}
              </div>
              <h4 className="text-base font-heading font-bold text-foreground-950 mb-2">
                {t.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center">
                  <span className="text-xs font-bold text-accent-700">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}